
import React from "react";
import {
  Card,
  CardContent,
  Typography,
   Box,
} from "@mui/material";

import { decrypt } from "../../components/cryptoUtil";

export default function OPDBill() {
  let decryptedData = {};
  try {
    const tokenData = localStorage.getItem("tokenData");
    decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  } catch (e) {
    console.warn("Failed to decrypt tokenData", e);
    decryptedData = {};
  }
  const token = localStorage.getItem("token") || "";
  const hospitalId = decryptedData.softsubgroup || "";

  return (
    <Card sx={{ mt: 3 }}>
      <CardContent>
         <Box
      sx={{
        backgroundColor: "darkblue",
        color: "white",
        p: .5,
        borderRadius: 2,
        marginBottom: 3,
        textAlign: "center",
      }}
    >
        <Typography variant="h5" gutterBottom>
         OPD Bill
        </Typography>
</Box>
        
      </CardContent>
    </Card>
  );
}
